import { createContext, useContext, useState, type ReactNode } from 'react'
import { useAuth } from './auth'

type TenantContextType = {
  activeTenantId: string
  setActiveTenantId: (id: string) => void
}

const TenantContext = createContext<TenantContextType>({
  activeTenantId: '',
  setActiveTenantId: () => {},
})

export function TenantProvider({ children }: { children: ReactNode }) {
  const [activeTenantId, setActiveTenantIdState] = useState<string>(
    () => localStorage.getItem('wsfull_active_tenant') ?? '',
  )

  function setActiveTenantId(id: string) {
    setActiveTenantIdState(id)
    if (id) localStorage.setItem('wsfull_active_tenant', id)
    else localStorage.removeItem('wsfull_active_tenant')
  }

  return (
    <TenantContext.Provider value={{ activeTenantId, setActiveTenantId }}>
      {children}
    </TenantContext.Provider>
  )
}

export function useTenant() {
  return useContext(TenantContext)
}

/** Returns the effective tenantId for the logged-in user.
 *  Operators use their own tenantId.
 *  Admins use the globally selected activeTenantId. */
export function useActiveTenant(): string {
  const { user } = useAuth()
  const { activeTenantId } = useTenant()
  return user?.tenantId ?? activeTenantId ?? ''
}
